// Transport — canon Phase 4. Events via fetch (keepalive) or sendBeacon on unload;
// control endpoints (session/attempts) best-effort. Dedup is by event_id only
// (sendBeacon carries no Idempotency-Key — canon note).
import type { ApiClient, Envelope, Transport } from './types';

export function createTransport(endpoint: string): Transport & ApiClient {
  const base = endpoint.replace(/\/$/, '');
  const url = (path: string): string => base + path;

  const postControl = async (path: string, body: Record<string, unknown>): Promise<void> => {
    try {
      await fetch(url(path), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'omit',
      });
    } catch {
      /* best effort — control calls are non-critical */
    }
  };

  return {
    async send(events: Envelope[], opts = {}): Promise<boolean> {
      const payload = JSON.stringify({ events });
      const target = url('/v1/analytics/events/batch');

      if (opts.beacon && typeof navigator !== 'undefined' && navigator.sendBeacon) {
        try {
          return navigator.sendBeacon(target, new Blob([payload], { type: 'application/json' }));
        } catch {
          return false;
        }
      }

      try {
        const res = await fetch(target, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          keepalive: Boolean(opts.beacon),
          credentials: 'omit',
        });
        return res.ok;
      } catch {
        return false;
      }
    },

    async startSession(body) {
      await postControl('/v1/analytics/session/start', body);
    },
    async createAttempt(body) {
      await postControl('/v1/analytics/quiz/attempts', body);
    },
    async patchAttempt(id, body) {
      try {
        await fetch(url(`/v1/analytics/quiz/attempts/${encodeURIComponent(id)}`), {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
          credentials: 'omit',
        });
      } catch {
        /* best effort */
      }
    },
  };
}
